import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "./config";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

// ✅ REQUEST INTERCEPTOR (FIXED)
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");

    if (token) {
      if (isTokenExpired(token)) {
        Cookies.remove("token", { path: "/" });
        Cookies.remove("user", { path: "/" });

        // ❌ DO NOT redirect here
        // ❌ DO NOT reject here
        return config;
      }

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ RESPONSE INTERCEPTOR (SAFE REDIRECT)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Cookies.remove("token");

      // safer redirect
      window.location.replace("/");
    }

    return Promise.reject(error);
  }
);

export default api;